var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.enginesData.hasEngines)?_c('router-view'):_c('LoadingView'),_c('FormCfgData')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }